import React from 'react';
import classnames from 'classnames';
import Select, {components} from 'react-select';
import {Field} from 'formik';
import arrowDown from '../../assets/arrow-select-black.svg';
import arrowDownActive from '../../assets/arrow-select-gold.svg';
import clear from '../../../modules/InspectedList/assets/cross.svg';
import styles from './styles.module.scss';

const defaultPlaceholder = 'בחר';
const emptyOption = {
  label: 'בחר',
  value: null,
};

const Control = customClassname => props => {

  return (
    <components.Control
      className={classnames(styles.control, {
        [styles.disabled]: props.isDisabled,
        [styles.focus]: props.isFocused && props.menuIsOpen && styles.focus
      }, customClassname)}  {...props}
    />
  );
};

const DropdownIndicator = noFocusChanges => props => {
  const arrow = (props.isFocused && props.selectProps.menuIsOpen)
    ? arrowDownActive : arrowDown;

  return noFocusChanges
    ? <img src={arrowDown} alt="arrow"/>
    : <img src={arrow} alt="arrow"/>;
};

const IndicatorsContainer = customClassname => props =>
  <components.IndicatorsContainer
    className={classnames(styles.indicatorsContainer, {[styles.disabled]: props.isDisabled}, customClassname)}
    {...props}
  />;

const Input = customClassname => props =>
  <components.Input
    className={classnames(styles.input, customClassname)}
    {...props}
  />;

const Placeholder = customClassname => props =>
  <components.Placeholder
    className={classnames(styles.placeholder, {[styles.disabled]: props.isDisabled}, customClassname)}
    {...props}
  />;

const SingleValue = customClassname => props =>
  <components.SingleValue
    className={classnames(styles.input, customClassname)}
    {...props}
  />;

const ValueContainer = customClassname => props =>
  <components.ValueContainer className={classnames(styles.valueContainer, customClassname)} {...props}/>;

const Menu = props =>
  <components.Menu className={styles.menu} {...props}/>;

const MenuList = props =>
  <components.MenuList className={styles.menuList} {...props}/>;

const CustomSelect = ({
                        field,
                        form,
                        meta,
                        containerStyles,
                        customControlStyles,
                        customIndicatorStyles,
                        customSingleValueStyles,
                        customValueContainerStyles,
                        noFocusChanges = false,
                        label,
                        mandatoryMark = false,
                        placeholder = defaultPlaceholder,
                        onChange,
                        onReset,
                        disabled,
                        options,
                        isSearchable = false,
                        id,
                        showCross = false,
                        hideResetOption = false,
                        menuPosition = 'absolute',
                        ...rest
                      }) => {
  const handleChange = (form, field) => option => {
    form.setFieldValue(field.name, option);
    if (onChange) {
      onChange(option);
    }
  };

  const handleReset = (form, field) => () => {
    form.setFieldValue(field.name, null);
    if (onReset) {
      onReset();
    }
  };

  const commonProps = {
    className: classnames(styles.select, {
      [styles.errorBorder]: meta.error && Object.keys(meta.error).length > 0 && meta.touched,
    }),
    value: field.value,
    onChange: handleChange(form, field),
    placeholder,
    isSearchable,
    isDisabled: disabled,
    components: {
      Control: Control(customControlStyles),
      DropdownIndicator: props => DropdownIndicator(noFocusChanges)(props),
      IndicatorSeparator: null,
      IndicatorsContainer: IndicatorsContainer(customIndicatorStyles),
      Input: Input(classnames({[styles.additionalPadding]: showCross})),
      Placeholder: Placeholder(classnames({[styles.additionalPadding]: showCross})),
      SingleValue: SingleValue(customSingleValueStyles, classnames({[styles.additionalPadding]: showCross})),
      ValueContainer: ValueContainer(customValueContainerStyles),
      MenuList,
      Menu,
      NoOptionsMessage: () => <div className={styles.noOptionsMessage}>{'אין אפשרויות זמינות'}</div>
    },
    menuPlacement: 'auto',
    menuPosition: menuPosition,
    maxMenuHeight: 500,
    minMenuHeight: 300,
    ...rest,
  };
  const staticProps = {
    options: Boolean(options)
      ? (showCross || hideResetOption)
        ? [...options]
        : [emptyOption, ...options]
      : []
  };
  const props = {...commonProps, ...staticProps};

  return (
    <div
      className={classnames(styles.selectContainer, containerStyles, {
        [styles.disabled]: disabled
      })}
    >
      {label && (
        <label
          htmlFor={id}
          className={classnames(styles.label, {[styles.errorText]: meta.error && Object.keys(meta.error).length > 0 && meta.touched})}
        >
          {mandatoryMark && <span className={styles.mandatoryMark}>*</span>}
          {label}
        </label>
      )}
      <div className={styles.selectInnerWrapper}>
        <Select {...props} inputId={id}/>
        {(!disabled) && showCross && (
          <img
            src={clear}
            className={classnames(styles.clearIcon, {[styles.disabled]: disabled})}
            alt="clear-date"
            onClick={handleReset(form, field)}
          />
        )}
      </div>
      {(id && meta.error && Object.keys(meta.error).length > 0 && meta.touched) && (
        <div className={classnames(styles.errorMessageOn)}>
          <p className={styles.errorText}>{meta.error}</p>
        </div>
      )}
    </div>
  );
};

const FieldSelect = ({
                       fieldId,
                       ...rest
                     }) => (
  <Field
    id={fieldId}
    name={fieldId}
  >
    {fieldProps => <CustomSelect {...fieldProps} {...rest} id={fieldId}/>}
  </Field>
);

export default FieldSelect;